import { atom } from "jotai";
import { FC } from "react";

import { Box, NavDesktopCategoryBar, NavMenuBar, SuperBanner } from "@theme/components";
import { NavigationDataProps } from "@theme/types";

/**
 * Menu Open Atom
 *
 * Whether any nav menu item is open
 * if open we need to prevent animations from closing the nav
 */
export const menuOpenAtom = atom(false);

/**
 * Nav Desktop Dropdown Open Atom
 *
 * Whether the Nav desktop dropdown is open
 * if open we need to darken the site based on designs
 */
export const navDesktopDropdownOpenAtom = atom(false);

/**
 * Drawer Open Atom
 *
 * Whether the mobile drawer is open or not.
 * this is needed for animating the super banner outside of Navigation scope.
 */
export const drawerOpenAtom = atom(false);

interface NavigationProps {
  isCheckout?: boolean;
  navData: NavigationDataProps;
  hideSpecialOfferBanner?: boolean;
}

export const Navigation: FC<NavigationProps> = ({
  isCheckout,
  navData,
  hideSpecialOfferBanner = false,
}) => {
  return (
    <Box as="header" sx={{ position: "fixed", width: "full", zIndex: 50 }}>
      {!hideSpecialOfferBanner && navData.siteNavData?.promoBanner && (
        <SuperBanner bannerData={navData.siteNavData.promoBanner} />
      )}

      <NavMenuBar navData={navData} isCheckout={isCheckout} />

      {!isCheckout && <NavDesktopCategoryBar navCategories={navData.siteNavData?.categories} />}
    </Box>
  );
};
